// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout-module--wrapper--1AMpk","skipLink":"layout-module--skipLink--3O0h6","mainWrapper":"layout-module--mainWrapper--23MCA"};